module.exports = __webpack_public_path__ + "img/goods-image-default.34806da2.jpg";